module.exports = __webpack_public_path__ + "static/media/main_visual_agriculture_telhandler_mlt_733_115_manitou.9547d88a.png";